import { useState } from 'react'
import { Btn } from '../ui/index.jsx'
import { useLanguage } from '../../i18n/index.jsx'
import SubscribeFeedDialog from '../calendar/SubscribeFeedDialog.jsx'

// Settings entry point for calendar feed subscriptions. Replaces the old
// single-token UI — the dialog now manages multiple labeled tokens with
// scope (mine/production/venue/all) and surfaces last-used + revoke.
//
// Legacy /api/cal/token endpoints stay live for 90 days for older clients;
// new UI talks exclusively to /api/cal/tokens (plural).

export default function CalendarFeedSettings() {
  const { t } = useLanguage()
  const [open, setOpen] = useState(false)

  return (
    <div style={{ paddingBottom: '1rem', borderBottom: '1px solid var(--border-subtle)' }}>
      <h3 style={{ fontSize: 'var(--text-base)', fontWeight: 600, marginBottom: '0.25rem' }}>
        {t('calendarFeed')}
      </h3>
      <p style={{ fontSize: 'var(--text-sm)', color: 'var(--text-muted)', marginBottom: '0.75rem' }}>
        {t('calendarFeedDesc')}
      </p>
      <Btn variant="primary" size="sm" onClick={() => setOpen(true)}>
        {t('calFeed.manage')}
      </Btn>
      <SubscribeFeedDialog
        open={open}
        onClose={() => setOpen(false)}
        defaultScope={{ scope_kind: 'mine', scope_id: null }}
      />
    </div>
  )
}
